















































































































































import Vue from "vue";
import { ref, onMounted, onBeforeUnmount, watch } from "@vue/composition-api";
import DonutChart from "./DonutChart.vue";
import { AppAnalytics } from "@/analytics";
import { emptyFn } from "@/fp";
import { state } from "../data/state";
export default Vue.extend({
  components: { DonutChart },
  props: {
    item: {
      type: Object,
    },
    openByDefault: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const isOpen = ref(false);
    const opened_sub_item = ref({});

    const toggle = () => {
      isOpen.value = !isOpen.value;
      if (isOpen.value) {
        AppAnalytics.report({
          component: "Investigation",
          // @ts-ignore
          eventName: `Investigation_tier#2 summary tab_entity's _click on ${props.item.name} in information Overview`,
        });
      }
    };

    const open_l1 = (id: string) => {
      opened_sub_item.value = {
        ...opened_sub_item.value,
        // @ts-ignore
        [id]: !opened_sub_item.value[id],
      };
    };

    const subs = {
      current_subject: emptyFn(),
    };

    onMounted(() => {
      setTimeout(() => {
        isOpen.value = props.openByDefault as boolean;
      }, 200);

      subs.current_subject = watch(state.current_subject, () => {
        isOpen.value = false;
      });
    });

    onBeforeUnmount(() => {
      Object.values(subs).forEach((unsub) => unsub());
    });

    return {
      isOpen,
      toggle,
      opened_sub_item,
      open_l1,
    };
  },
});
